import { gql } from 'graphql-request'
import { fragmentBlocksQuery } from '../fragments/blocks'

export const SingleProgrammeQuery = gql`
  query SingleProgramme(
    $slug: String!,
    $isPreview: Boolean! = false,
    $statuses: [Programme__status_Input] = [published],
    $locale: LocaleInputType!
  ) {
    Programmes(
      draft: $isPreview,
      locale: $locale,
      where: {
        AND: [
          { slug: { equals: $slug } }
          { _status: { in: $statuses } }
        ]
      }
    ) {
      docs {
        id
        title
        slug
        description
        ticketUrl
        ticketUrlLabel
        image ${fragmentMediaQuery}
        recurrences {
          id
          dateTimeStart
          dateTimeEnd
        }
        type {
          ... on ProgrammeType {
            id
            title
            slug
          }
        }
        rooms {
          ... on Room {
            id
            title
            slug
          }
        }
        people {
          ... on Person {
            id
            title
            slug
          }
        }
        content {
          ${fragmentBlockHeadingQuery}
          ${fragmentBlockRichTextQuery}
          ${fragmentBlockSummaryQuery}
          ${fragmentsBlockDownloadQuery}
          ${fragmentBlockLinksQuery}
          ${fragmentBlockMediaArrayQuery}
          ${fragmentBlockPersonListQuery}
        }
      }
    }
  }
`
